import React from "react";

const FirebaseAuthContext = React.createContext();

export default FirebaseAuthContext;